// Verbatim from the backend enum `prepayment_options` (eastview-os
// app/models/underwriting.py), same order. "7% 6% 5% 4% 3% 2% 1%" (7-year
// declining) landed there 2026-10-01; DSCR pricing accepts it too
// (pricing_structures.PREPAY_OPTIONS = prepayment_options).
export const selectOptionsPrepaymentPenaltyStructure = [
  "7% 6% 5% 4% 3% 2% 1%",
  "5% 5% 5% 5% 5%",
  "1% 1% 1% 1% 1%",
  "5% 4% 3% 2% 1%",
  "4% 3% 2% 1%",
  "3% 2% 1%",
  "2% 1%",
  "1%",
  "Interest Payments",
  "Other Points",
  "No PPP",
];
